<!-- ================= LISTA ================= -->
@if (!detalheDe) {
  <div class="modal-header" mat-dialog-title>
    <div class="modal-header-icon">
      <mat-icon class="material-symbols-outlined">manage_search</mat-icon>
    </div>
    <div class="modal-header-titles">
      <h2 class="modal-title">Busca avançada de produtos</h2>
      <p class="modal-subtitle">Itens do documento</p>
    </div>
    <div class="modal-header-close-btn-container">
      <button mat-icon-button type="button" class="modal-close-btn" aria-label="Fechar"
        (click)="fechar()">
        <mat-icon class="material-symbols-outlined">close</mat-icon>
      </button>
    </div>
  </div>

  <mat-dialog-content class="vpb-conteudo">
    <p class="vpb-sub">{{ subtitulo }}</p>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Pesquisar ou bipar</mat-label>
      <!-- O leitor de código de barras é um teclado: digita aqui e envia Enter. Código exato lança
           direto; o resto busca por conteúdo. Sem Enter, a busca dispara sozinha após a pausa. -->
      <input matInput [formControl]="termo" (keydown.enter)="$event.preventDefault(); pesquisar()" cdkFocusInitial
        autocomplete="off" placeholder="Descrição, código (SKU), GTIN/EAN ou leitura do código de barras">
      <!-- Leitor de câmera: só faz sentido no celular (CSS esconde no desktop). -->
      <button class="icon-mat-symbols-btn vpb-camera" matSuffix mat-icon-button type="button"
        matTooltip="Ler código de barras com a câmera" aria-label="Ler código de barras" (click)="abrirLeitor()">
        <mat-icon class="material-symbols-outlined">barcode_scanner</mat-icon>
      </button>
      <!-- O MESMO menu da lista de produtos (Cadastros >> Produtos), na mesma ordem: quem já
           sabe procurar lá não precisa reaprender aqui. -->
      <button class="icon-mat-symbols-btn" matSuffix mat-icon-button [matMenuTriggerFor]="refinarMenu" type="button"
        aria-label="Refinar busca" matTooltip="Refinar busca">
        <mat-icon>tune</mat-icon>
      </button>
      <mat-menu #refinarMenu="matMenu">
        <button mat-menu-item (click)="filtroRefinar = null">
          @if (filtroRefinar === null) {
          <mat-icon>check</mat-icon>
          }
          <span [class.ps-4]="filtroRefinar !== null">Não refinar</span>
        </button>
        <button mat-menu-item (click)="filtroRefinar = refinamentoEnum.CodigoSku">
          @if (filtroRefinar === refinamentoEnum.CodigoSku) {
          <mat-icon>check</mat-icon>
          }
          <span [class.ps-4]="filtroRefinar !== refinamentoEnum.CodigoSku">Código</span>
        </button>
        <button mat-menu-item (click)="filtroRefinar = refinamentoEnum.CodigoFornecedor">
          @if (filtroRefinar === refinamentoEnum.CodigoFornecedor) {
          <mat-icon>check</mat-icon>
          }
          <span [class.ps-4]="filtroRefinar !== refinamentoEnum.CodigoFornecedor">Código do Fornecedor</span>
        </button>
        <button mat-menu-item (click)="filtroRefinar = refinamentoEnum.GtinEan">
          @if (filtroRefinar === refinamentoEnum.GtinEan) {
          <mat-icon>check</mat-icon>
          }
          <span [class.ps-4]="filtroRefinar !== refinamentoEnum.GtinEan">GTIN/EAN</span>
        </button>
        <button mat-menu-item (click)="filtroRefinar = refinamentoEnum.Descricao">
          @if (filtroRefinar === refinamentoEnum.Descricao) {
          <mat-icon>check</mat-icon>
          }
          <span [class.ps-4]="filtroRefinar !== refinamentoEnum.Descricao">Descrição</span>
        </button>
        <button mat-menu-item (click)="filtroRefinar = refinamentoEnum.PalavrasChave">
          @if (filtroRefinar === refinamentoEnum.PalavrasChave) {
          <mat-icon>check</mat-icon>
          }
          <span [class.ps-4]="filtroRefinar !== refinamentoEnum.PalavrasChave">Palavras-chave</span>
        </button>
      </mat-menu>

      <button class="icon-mat-symbols-btn" matSuffix mat-icon-button type="button" matTooltip="Pesquisar" (click)="pesquisar()">
        <mat-icon class="material-symbols-outlined">search</mat-icon>
      </button>
    </mat-form-field>

    @if (buscando) {
      <div class="vpb-vazio">
        <mat-spinner diameter="32"></mat-spinner>
        <span>Procurando produtos…</span>
      </div>
    } @else if (!pesquisou) {
      <div class="vpb-vazio">
        <mat-icon class="material-symbols-outlined vpb-icone">inventory_2</mat-icon>
        <span>Digite um termo e pesquise. Sem termo, a busca traz os primeiros produtos do catálogo.</span>
      </div>
    } @else if (!resultados.length) {
      <div class="vpb-vazio">
        <mat-icon class="material-symbols-outlined vpb-icone">search_off</mat-icon>
        <span>Nenhum produto encontrado. Tente outro termo — a busca procura em descrição, código e GTIN/EAN.</span>
      </div>
    } @else {
      <div class="vpb-contagem">
        exibindo {{ resultados.length }} de {{ totalDeResultados }}
        {{ totalDeResultados === 1 ? 'produto' : 'produtos' }}
      </div>

      <div class="vpb-tabela">
        <div class="vpb-cabecalho">
          <span class="vpb-c-radio"></span>
          <span class="vpb-c-desc">Descrição</span>
          <span class="vpb-c-sku">Código (SKU)</span>
          <span class="vpb-c-num">Preço</span>
          <span class="vpb-c-num">Estoque</span>
          <span class="vpb-c-num">Disponível</span>
          <span class="vpb-c-acao"></span>
        </div>

        @for (p of resultados; track p.idProduto) {
          <div class="vpb-linha" [class.vpb-linha-ativa]="selecionado?.idProduto === p.idProduto"
            (click)="selecionar(p)">
            <span class="vpb-c-radio">
              <span class="vpb-radio" [class.vpb-radio-ativo]="selecionado?.idProduto === p.idProduto"></span>
            </span>

            <span class="vpb-c-desc">
              {{ p.descricao }}
              @if (p.isKit) {
                <span class="status-badge badge-amarelo">Kit</span>
              }
              @if (p.gtinEan) {
                <small class="vpb-ean">EAN {{ p.gtinEan }}</small>
              }
            </span>

            <!-- `data-rotulo`: no celular o cabecalho da tabela some e cada numero leva o seu rotulo. -->
            <span class="vpb-c-sku" data-rotulo="SKU">{{ p.codigoSku || '—' }}</span>

            <!-- Preço resolvido entre as listas (§6.2.2.3), com o rastreio quando veio de outra lista. -->
            <span class="vpb-c-num" data-rotulo="Preço">
              {{ precoDe(p) | abnt: 'preco' }}
              @if (rastreioDe(p); as rastreio) {
                <mat-icon class="material-symbols-outlined vpb-rastreio" [matTooltip]="rastreio">sell</mat-icon>
              }
            </span>

            <span class="vpb-c-num" data-rotulo="Estoque">
              <!-- Popover, e não linha expansível: o saldo por localização é consulta de apoio,
                   e abrir uma faixa no meio da lista empurra as outras linhas para longe do
                   cursor. `matMenuContent` é lazy, então a consulta só sai quando alguém abre. -->
              <button type="button" class="vpb-link" [matMenuTriggerFor]="menuEstoque"
                matTooltip="Ver estoque por localização"
                (click)="selecionar(p); carregarEstoques(p); $event.stopPropagation()">
                {{ p.saldoFisico ?? 0 | abnt: 'quantidade' }}
              </button>

              <mat-menu #menuEstoque="matMenu" class="vpb-menu-estoque">
                <ng-template matMenuContent>
                  <div class="vpb-estoque-titulo">Estoques</div>

                  @if (carregandoEstoques) {
                    <div class="vpb-estoque-linha"><span>Carregando…</span><span></span></div>
                  } @else if (!estoquesDoProduto(p).length) {
                    <div class="vpb-estoque-linha"><span>Sem saldo em nenhuma localização.</span><span></span></div>
                  } @else {
                    @for (e of estoquesDoProduto(p); track e.idLocalizacaoEstoque) {
                      <div class="vpb-estoque-linha">
                        <span>{{ e.localizacao || e.codigoLocalizacao || 'Sem localização' }}</span>
                        <span>{{ e.saldoDisponivel | abnt: 'quantidade' }}</span>
                      </div>
                    }

                    <div class="vpb-estoque-linha vpb-estoque-total">
                      <span>Todos</span>
                      <span>{{ totalDosEstoques(p) | abnt: 'quantidade' }}</span>
                    </div>
                  }
                </ng-template>
              </mat-menu>
            </span>

            <span class="vpb-c-num" data-rotulo="Disponível">{{ p.saldoDisponivel ?? 0 | abnt: 'quantidade' }}</span>

            <span class="vpb-c-acao">
              <button type="button" class="vpb-link" (click)="abrirDetalhe(p); $event.stopPropagation()">
                detalhes
              </button>
            </span>
          </div>

        }
      </div>

      @if (temMais) {
        <div class="vpb-ver-mais">
          <button mat-button type="button" [disabled]="carregandoMais" (click)="verMais()">
            @if (carregandoMais) {
              <mat-spinner diameter="18"></mat-spinner>
            } @else {
              <mat-icon class="material-symbols-outlined">expand_more</mat-icon>
            }
            {{ rotuloVerMais }}
          </button>
        </div>
      }
    }
  </mat-dialog-content>

  <mat-dialog-actions class="vpb-acoes">
    <button mat-stroked-button type="button" class="btn-secondary" (click)="fechar()">Fechar</button>
    <button mat-flat-button type="button" class="btn-primary" [disabled]="!selecionado" (click)="adicionar()">
      <mat-icon class="material-symbols-outlined">add</mat-icon>
      Adicionar item
    </button>
  </mat-dialog-actions>
}

<!-- ================= LEITOR DE CÂMERA (mobile) ================= -->
@if (scannerAberto) {
  <app-inventario-scanner-mobile (codigoLido)="aoLerCodigo($event)" (fechar)="fecharLeitor()">
  </app-inventario-scanner-mobile>
}

<!-- ================= DETALHE ================= -->
@if (detalheDe) {
  <div class="modal-header" mat-dialog-title>
    <div class="modal-header-icon">
      <mat-icon class="material-symbols-outlined">inventory_2</mat-icon>
    </div>
    <div class="modal-header-titles">
      <h2 class="modal-title">{{ detalheDe.descricao }}</h2>
      <p class="modal-subtitle">Detalhes do produto</p>
    </div>
    <div class="modal-header-close-btn-container">
      <button mat-icon-button type="button" class="modal-close-btn" aria-label="Fechar"
        (click)="fechar()">
        <mat-icon class="material-symbols-outlined">close</mat-icon>
      </button>
    </div>
  </div>

  <mat-dialog-content class="vpb-conteudo">
    <div class="row">
      <div class="col-6 col-md-3">
        <div class="vpb-rotulo">Código (SKU)</div>
        <div class="vpb-valor">{{ detalheDe.codigoSku || '—' }}</div>
      </div>
      <div class="col-6 col-md-3">
        <div class="vpb-rotulo">GTIN / EAN</div>
        <div class="vpb-valor">{{ detalheDe.gtinEan || '—' }}</div>
      </div>
      <div class="col-6 col-md-3">
        <div class="vpb-rotulo">Preço</div>
        <div class="vpb-valor">{{ detalheDe.preco ?? 0 | abnt: 'preco' }}</div>
      </div>
      <div class="col-6 col-md-3">
        <div class="vpb-rotulo">NCM</div>
        <div class="vpb-valor">{{ detalheDe.ncm || '—' }}</div>
      </div>
      <div class="col-6 col-md-3">
        <div class="vpb-rotulo">Unidade</div>
        <div class="vpb-valor">{{ detalheDe.unidade || '—' }}</div>
      </div>
      <div class="col-6 col-md-3">
        <div class="vpb-rotulo">Estoque</div>
        <div class="vpb-valor">{{ detalheDe.saldoFisico ?? 0 | abnt: 'quantidade' }}</div>
      </div>
      <div class="col-6 col-md-3">
        <div class="vpb-rotulo">Disponível</div>
        <div class="vpb-valor">{{ detalheDe.saldoDisponivel ?? 0 | abnt: 'quantidade' }}</div>
      </div>
    </div>

    <mat-form-field appearance="outline" class="w-100 mt-3">
      <mat-label>Descrição complementar</mat-label>
      <textarea matInput rows="3" [formControl]="descricaoComplementar"
        placeholder="Observação impressa junto ao item"></textarea>
      <mat-hint>Entra na linha junto com o item, e pode ser alterada depois no modal de edição.</mat-hint>
    </mat-form-field>

    <h3 class="vpb-titulo-bloco">Estoque por localização</h3>

    <div class="vpb-tabela">
      <div class="vpb-cabecalho vpb-cabecalho-estoque">
        <span>Localização</span>
        <span class="vpb-c-num">Disponível</span>
      </div>

      @if (carregandoEstoques) {
        <div class="vpb-estoque-linha"><span>Carregando o estoque…</span><span></span></div>
      } @else if (!estoquesDoProduto(detalheDe).length) {
        <div class="vpb-estoque-linha"><span>Sem saldo em nenhuma localização.</span><span></span></div>
      } @else {
        @for (e of estoquesDoProduto(detalheDe); track e.idLocalizacaoEstoque) {
          <div class="vpb-estoque-linha">
            <span>{{ e.localizacao || e.codigoLocalizacao || 'Sem localização' }}</span>
            <span>{{ e.saldoDisponivel | abnt: 'quantidade' }}</span>
          </div>
        }
      }
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="vpb-acoes">
    <button mat-stroked-button type="button" class="btn-secondary" (click)="voltarParaLista()">Voltar</button>
    <button mat-flat-button type="button" class="btn-primary" (click)="adicionar()">
      <mat-icon class="material-symbols-outlined">add</mat-icon>
      Adicionar item
    </button>
  </mat-dialog-actions>
}
